import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { employeeApiKeyStore } from '../../../../api/masters/employee-api-key-store';
import { Icons } from '../../../../assets/icons';
import { SiTrackPage } from '../../../../components/si-track-page';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Employee } from '../../../../models/masters/employee';
import { CalendarComponent } from '../../../inspector-calendar/calendar.component';
import { AssignedServiceInspection } from './assigned-service-inspection.component';
import { AssignedWorkorderInspection } from './assigned-workorder-inspection.component';
import { AssignedEquipmentInspection } from './assigned-equipment-inspection.component';

const EmployeeProfilePage = () => {
  const { id } = useParams();
  const { data, isLoading } = useLoadData<ApiResponse<Employee>>(employeeApiKeyStore.getEmployeeDetails(id));
  // console.log(56, data);
  return (
    <SiTrackPage title="Employee profile">
      <Grid container spacing={2}>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Card elevation={0}>
            <CardHeader
              className="subHead"
              title={
                <Typography variant="h3" color="textPrimary">
                  Employee Info
                </Typography>
              }
            ></CardHeader>
            <CardContent className="formContainer">
              <Grid container spacing={2}>
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Employee Name:&nbsp;</label>
                  <strong> {`${data?.data?.firstName ? `${data?.data?.firstName} ` : ''}${data?.data?.lastName ?? ''}`} </strong>
                </Grid>
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Role:&nbsp;</label>
                  <strong>{data?.data?.userRoles}</strong>
                </Grid>
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Reporting Manager:&nbsp;</label>
                  <strong>{data?.data?.userManagers ?? ''}</strong>
                </Grid>{' '}
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Department:&nbsp;</label>
                  <strong>{data?.data?.userDepartments ?? ''}</strong>
                </Grid>{' '}
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Market Area:&nbsp;</label>
                  <strong>{data?.data?.userMarketAreas ?? ''}</strong>
                </Grid>{' '}
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Skills:&nbsp;</label>
                  <strong>{data?.data?.userSkillsets ?? ''}</strong>
                </Grid>
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Address:&nbsp;</label>
                  <strong>{data?.data?.userFullAddress ?? ''}</strong>
                </Grid>
                <Grid item lg={3} sm={3} xl={3} xs={3} display={'flex'} flexDirection={'column'}>
                  <label>Contact Information:&nbsp;</label>
                  <strong>{`${data?.data?.mobile ? `${data?.data?.mobile}, ` : ''}${data?.data?.email ?? ''}`}</strong>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <AssignedServiceInspection userAssignableServices={data?.data?.userAssignableServices ?? []} isLoading={isLoading} />
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Grid container spacing={1}>
            <Grid item lg={8} sm={8} xl={8} xs={8}>
              <AssignedWorkorderInspection inspectorWOEvents={data?.data?.inspectorWOEvents ?? []} isLoading={isLoading} />
            </Grid>
            <Grid item lg={4} sm={4} xl={4} xs={4}>
              <AssignedEquipmentInspection userEquipments={data?.data?.userEquipments ?? []} isLoading={isLoading} />
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid container>
        <Card elevation={0} className="" style={{ marginTop: '15px', width: '49.5%' }}>
          <CardHeader
            className="subHead"
            title={
              <Typography variant="h3" color="textPrimary">
                Leave Tracking
              </Typography>
            }
          ></CardHeader>
          <CardContent className="formContainer">
            <Grid container spacing={2}>
              <Grid item lg={6} sm={6} xl={6} xs={6} display={'flex'} flexDirection={'column'}>
                <label>Applied leave :&nbsp;</label>
                <strong>-</strong>
              </Grid>
              <Grid item lg={6} sm={6} xl={6} xs={6} display={'flex'} flexDirection={'column'}>
                <label>Status:&nbsp;</label>
                <strong>-</strong>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card elevation={0} className="" style={{ marginTop: '15px', marginLeft: '1%', width: '49.5%' }}>
          <CardHeader
            className="subHead"
            title={
              <Typography variant="h3" color="textPrimary">
                Upcoming leave
              </Typography>
            }
          ></CardHeader>
          <CardContent className="formContainer">
            <Grid container spacing={2}>
              <Grid item lg={6} sm={6} xl={6} xs={6} display={'flex'} flexDirection={'column'}>
                <label>Description:&nbsp;</label>
                <strong>-</strong>
              </Grid>
              <Grid item lg={6} sm={6} xl={6} xs={6} display={'flex'} flexDirection={'column'}>
                <label>Status:&nbsp;</label>
                <strong>-</strong>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid> */}

        {/* <Grid container style={{ marginTop: '15px', marginBottom: '15px' }}>
        <Card elevation={0}>
          <CardHeader
            className="subHead"
            title={
              <Typography variant="h3" color="textPrimary">
                Inspection Calendar
              </Typography>
            }
          ></CardHeader>
          <CardContent className="formContainer">
            <Grid container spacing={2}>
              <Grid item lg={12} sm={12} xl={12} xs={12} display={'flex'} flexDirection={'column'}>
                {/* <img src={Icons.IconCalendar} alt="Schedule" /> */}
        {/* <CalendarComponent workorderEvent={data?.data?.inspectorWOEvents} height={645} isLoading={isLoading} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>   */}
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Card elevation={0} className="">
            <CardHeader
              className="subHead"
              title={
                <Typography variant="h3" color="textPrimary">
                  Inspection Calendar
                </Typography>
              }
            ></CardHeader>
            <CardContent className="formContainer">
              <CalendarComponent workorderEvent={data?.data?.inspectorWOEvents} height={645} isLoading={isLoading} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </SiTrackPage>
  );
};

export default EmployeeProfilePage;
